import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../../store/reducers/gantSlice/gantSlice';

export const useHeaderInterface = () => {
    const { settings } = useSelector((state) => state.gantReducer);
    const dispatch = useDispatch();

    const onSwitchChange = () => {
        $.ajax({
            url: `${routable.getRoute('estimateScheduleSaveSettings')}?viewMaterial=${
                !settings.isShowMHD ? 1 : 0
            }`,
            success: function () {},
        });
        dispatch(gantActions.changeSettings({ ...settings, isShowMHD: !settings.isShowMHD }));
    };
    return {
        settings,
        onSwitchChange,
    };
};
